module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image10-b59c697d22a8045f3a5ae9ca9597aa51.jpg";